import { UserRepository } from '@/context/global/api/repository/user';
import { AxiosInstance } from 'axios';

export const UserAPI = (axios: AxiosInstance): UserRepository => {
  return {
    GetUserProfile() {
      return axios.get('/web/content/user/profile/all');
    },
    PostProfileEdit(req) {
      const formData = new FormData();
      formData.append('file', req.file);
      formData.append('name', req.aliasName);

      return axios.post('/web/content/user/profile/edit', formData);
    },
    GetProfileImageList() {
      return axios.get('/web/content/user/profile/images');
    },
    GetTermPolicy() {
      return axios.get('/web/webview/termPolicy');
    },
    GetTermPrivacy() {
      return axios.get('/web/webview/termPrivacy');
    },
    GetFavorite() {
      return axios.get('/web/content/user/profile/favorite');
    },
  };
};
